// extracted by mini-css-extract-plugin
module.exports = {"root":"Timestamp__root___rMLND","original":"Timestamp__original___1xsRG"};